/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import CalendarLocale from '../calendar/ro_RO';
import TimePickerLocale from '../time-picker/ro_RO';

// Merge into a locale object
const locale = {
  lang: {
    placeholder: 'SelecteazÄ data',
    rangePlaceholder: ['Data start', 'Data sfÃ¢rÈit'],
    ...CalendarLocale
  },
  timePickerLocale: {
    ...TimePickerLocale
  }
};

export default locale;
